import React, { useState, useRef, useEffect } from "react"
import "./ModalAdventCalendar.scss"
import MagnifierSvg from "@images/magnifier.svg"

// talents画像
import drNovaE from "@images/advent-calendar-content/artist-box-img/artistBox-dr-nova-e.png"
import pomaPon from "@images/advent-calendar-content/artist-box-img/artistBox-poma-pon.png"
import terra404 from "@images/advent-calendar-content/artist-box-img/artistBox-terra404.png"
import remKanashibari from "@images/advent-calendar-content/artist-box-img/artistBox-rem-kanashibari.png"
import yaeYugiri from "@images/advent-calendar-content/artist-box-img/artistBox-yae-yugiri.png"
import monoMonet from "@images/advent-calendar-content/artist-box-img/artistBox-mono-monet.png"
import yumiTheWitch from "@images/advent-calendar-content/artist-box-img/artistBox-yumi-the-witch.png"
import aliasAnono from "@images/advent-calendar-content/artist-box-img/artistBox-alias-anono.png"
import kouMariya from "@images/advent-calendar-content/artist-box-img/artistBox-kou-mariya.png"
import lykoLianna from "@images/advent-calendar-content/artist-box-img/artistBox-lyko-lianna.png"
import serinaMaiko from "@images/advent-calendar-content/artist-box-img/artistBox-serina-maiko.png"
import raraRocora from "@images/advent-calendar-content/artist-box-img/artistBox-rara-rocora.png"
import veeSensei from "@images/advent-calendar-content/artist-box-img/artistBox-vee-sensei.png"
import consertLogo from "@images/concert-logo.png"

// 表示画像
import modalAdventCalendarImgDay1 from "@images/advent-calendar-content/content-img/V4Mirai-chibi-wallpaper_1440x2560.png"
import modalAdventCalendarImgDay3 from "@images/advent-calendar-content/content-img/mirai-magical-school-winter-festival_03.jpg"
import modalAdventCalendarImgDay6 from "@images/advent-calendar-content/content-img/mirai-magical-school-winter-festival_06.png"
import modalAdventCalendarImgDay7 from "@images/advent-calendar-content/content-img/mirai-magical-school-winter-festival_07.png"
import modalAdventCalendarImgDay9 from "@images/advent-calendar-content/content-img/mirai-magical-school-winter-festival_09.png"
import modalAdventCalendarImgDay10 from "@images/advent-calendar-content/content-img/mirai-magical-school-winter-festival_10.gif"
import modalAdventCalendarImgDay14 from "@images/advent-calendar-content/content-img/mirai-magical-school-winter-festival_14.png"
import modalAdventCalendarImgDay15 from "@images/advent-calendar-content/content-img/mirai-magical-school-winter-festival_15.jpg"
import modalAdventCalendarImgDay16 from "@images/advent-calendar-content/content-img/mirai-magical-school-winter-festival_16.png"
import modalAdventCalendarImgDay20 from "@images/advent-calendar-content/content-img/mirai-magical-school-winter-festival_20.png"
import modalAdventCalendarImgDay24 from "@images/advent-calendar-content/content-img/mirai-magical-school-winter-festival_24.png"

const adventCalendarContent = {
  1: {
    modalAdventCalendarImg: modalAdventCalendarImgDay1,
    calendarContentImgAlt: "advent calendar content day 1",
    downloadImageHref: `${__PATH_PREFIX__}/images/mirai-magical-school-winter-festival_01.zip`,
    downloadImageName: "mirai-magical-school-winter-festival_01.zip",
    dataGtmClick: "adventCalenderContent-downloadDay1",
    imageEnlargement: modalAdventCalendarImgDay1,
  },
  2: {
    artistBoxImg1: drNovaE,
    artistBoxImgAlt1: "Dr.NOVA(e)",
    artistBoxName1: "Dr.NOVA(e)",
    adventCalendarYoutube1:
      "https://www.youtube.com/embed/TVPWog45iC4?si=qX_Lx1sm_nJBrJzO",
  },
  3: {
    artistBoxImg1: pomaPon,
    artistBoxImgAlt1: "Poma Pon",
    artistBoxName1: "Poma Pon",
    modalAdventCalendarImg: modalAdventCalendarImgDay3,
    downloadImageHref: `${__PATH_PREFIX__}/images/mirai-magical-school-winter-festival_03.zip`,
    downloadImageName: "mirai-magical-school-winter-festival_03.zip",
    dataGtmClick: "adventCalenderContent-downloadDay3",
    imageEnlargement: modalAdventCalendarImgDay3,
  },
  4: {
    artistBoxImg1: remKanashibari,
    artistBoxImgAlt1: "REM Kanashibari",
    artistBoxName1: "REM Kanashibari",
    artistBoxImg2: terra404,
    artistBoxImgAlt2: "Terra404",
    artistBoxName2: "Terra404",
    adventCalendarYoutube1:
      "https://www.youtube.com/embed/wJp0JCNKwHE?si=3bcbJuSpCjk55w-x",
  },
  5: {
    artistBoxImg1: yaeYugiri,
    artistBoxImgAlt1: "Yae Yugiri",
    artistBoxName1: "Yae Yugiri",
    adventCalendarYoutube1: "https://www.youtube.com/embed/ppPYouUKKKM",
  },
  6: {
    artistBoxImg1: monoMonet,
    artistBoxImgAlt1: "Mono Monet",
    artistBoxName1: "Mono Monet",
    modalAdventCalendarImg: modalAdventCalendarImgDay6,
    downloadImageHref: `${__PATH_PREFIX__}/images/mirai-magical-school-winter-festival_06.zip`,
    downloadImageName: "mirai-magical-school-winter-festival_06.zip",
    dataGtmClick: "adventCalenderContent-downloadDay6",
    imageEnlargement: modalAdventCalendarImgDay6,
  },
  7: {
    artistBoxImg1: yumiTheWitch,
    artistBoxImgAlt1: "Yumi the Witch",
    artistBoxName1: "Yumi the Witch",
    modalAdventCalendarImg: modalAdventCalendarImgDay7,
    downloadImageHref: `${__PATH_PREFIX__}/images/mirai-magical-school-winter-festival_07.png`,
    downloadImageName: "mirai-magical-school-winter-festival_07.png",
    dataGtmClick: "adventCalenderContent-downloadDay7",
    imageEnlargement: modalAdventCalendarImgDay7,
  },
  8: {
    artistBoxImg1: aliasAnono,
    artistBoxImgAlt1: "Alias Anono",
    artistBoxName1: "Alias Anono",
    artistBoxImg2: drNovaE,
    artistBoxImgAlt2: "Dr.NOVA(e)",
    artistBoxName2: "Dr.NOVA(e)",
    adventCalendarYoutube1:
      "https://www.youtube.com/embed/gEcYmjFxuv4?si=CaBPRXRtED5V6dMi",
    downloadImageHref: `${__PATH_PREFIX__}/images/mirai-magical-school-winter-festival_08.zip`,
    downloadImageName: "mirai-magical-school-winter-festival_08.zip",
    dataGtmClick: "adventCalenderContent-downloadDay8",
  },
  9: {
    artistBoxImg1: kouMariya,
    artistBoxImgAlt1: "Kou Mariya",
    artistBoxName1: "Kou Mariya",

    modalAdventCalendarImg: modalAdventCalendarImgDay9,
    downloadImageHref: `${__PATH_PREFIX__}/images/mirai-magical-school-winter-festival_09.zip`,
    downloadImageName: "mirai-magical-school-winter-festival_09.zip",
    dataGtmClick: "adventCalenderContent-downloadDay9",
    imageEnlargement: modalAdventCalendarImgDay9,
  },
  10: {
    artistBoxImg1: lykoLianna,
    artistBoxImgAlt1: "Lyko Lianna",
    artistBoxName1: "Lyko Lianna",
    modalAdventCalendarImg: modalAdventCalendarImgDay10,
    downloadImageHref: `${__PATH_PREFIX__}/images/mirai-magical-school-winter-festival_10.zip`,
    downloadImageName: "mirai-magical-school-winter-festival_10.zip",
    dataGtmClick: "adventCalenderContent-downloadDay10",
    imageEnlargement: modalAdventCalendarImgDay10,
  },
  11: {
    artistBoxImg1: serinaMaiko,
    artistBoxImgAlt1: "Serina Maiko",
    artistBoxName1: "Serina Maiko",
    adventCalendarYoutube1:
      "https://www.youtube.com/embed/lGYarf3zqrM?si=H_YZCrE4mCo-9h37",
  },
  12: {
    adventCalendarYoutube1:
      "https://www.youtube.com/embed/6Rld6QyXhiM?si=N3TkIK5S-BS4qmuH",
  },
  13: {
    artistBoxImg1: remKanashibari,
    artistBoxImgAlt1: "REM Kanashibari",
    artistBoxName1: "REM Kanashibari",
    adventCalendarYoutube1:
      "https://www.youtube.com/embed/0CsOO5pxgkc?si=icarp_aOKD08Ca2Y",
  },
  14: {
    artistBoxImg1: raraRocora,
    artistBoxImgAlt1: "Rara Rocora",
    artistBoxName1: "Rara Rocora",
    artistBoxImg2: kouMariya,
    artistBoxImgAlt2: "Kou Mariya",
    artistBoxName2: "Kou Mariya",
    modalAdventCalendarImg: modalAdventCalendarImgDay14,
    downloadImageHref: `${__PATH_PREFIX__}/images/mirai-magical-school-winter-festival_14.zip`,
    downloadImageName: "mirai-magical-school-winter-festival_14.zip",
    dataGtmClick: "adventCalenderContent-downloadDay14",
    imageEnlargement: modalAdventCalendarImgDay14,
  },
  15: {
    artistBoxImg1: serinaMaiko,
    artistBoxImgAlt1: "Serina Maiko",
    artistBoxName1: "Serina Maiko",
    artistBoxImg2: pomaPon,
    artistBoxImgAlt2: "Poma Pon",
    artistBoxName2: "Poma Pon",
    modalAdventCalendarImg: modalAdventCalendarImgDay15,
    downloadImageHref: `${__PATH_PREFIX__}/images/mirai-magical-school-winter-festival_15.zip`,
    downloadImageName: "mirai-magical-school-winter-festival_15.zip",
    dataGtmClick: "adventCalenderContent-downloadDay15",
    imageEnlargement: modalAdventCalendarImgDay15,
  },
  16: {
    artistBoxImg1: aliasAnono,
    artistBoxImgAlt1: "Alias Anono",
    artistBoxName1: "Alias Anono",
    modalAdventCalendarImg: modalAdventCalendarImgDay16,
    downloadImageHref: `${__PATH_PREFIX__}/images/mirai-magical-school-winter-festival_16-yu1jmwskxkzxginvj9tu4aogx86ddv.png`,
    downloadImageName: "mirai-magical-school-winter-festival_16.png",
    dataGtmClick: "adventCalenderContent-downloadDay16",
    imageEnlargement: modalAdventCalendarImgDay16,
  },
  17: {
    artistBoxImg1: yaeYugiri,
    artistBoxImgAlt1: "Yae Yugiri",
    artistBoxName1: "Yae Yugiri",
    artistBoxImg2: yumiTheWitch,
    artistBoxImgAlt2: "Yumi the Witch",
    artistBoxName2: "Yumi the Witch",
    adventCalendarYoutube1:
      "https://www.youtube.com/embed/6rqDKSH0FGY?si=01SNZ3G4mcFATjcF",
  },
  18: {
    artistBoxImg1: terra404,
    artistBoxImgAlt1: "Terra404",
    artistBoxName1: "Terra404",
    adventCalendarYoutube1:
      "https://www.youtube.com/embed/Meh5O5bDWOU?si=7L7pBxfwYg6TC52O",
  },
  19: {
    artistBoxImg1: veeSensei,
    artistBoxImgAlt1: "Vee Sensei",
    artistBoxName1: "Vee Sensei",
    adventCalendarYoutube1:
      "https://www.youtube.com/embed/AFvr-35gHT0?si=_gQDrytOTO8FHIFv",
  },
  20: {
    modalAdventCalendarImg: modalAdventCalendarImgDay20,
    downloadImageHref: `${__PATH_PREFIX__}/images/mirai-magical-school-winter-festival_20-VqkHh3LLoUeAjBYMI6sr9hQUXHutiu.png`,
    downloadImageName: "mirai-magical-school-winter-festival_20.png",
    dataGtmClick: "adventCalenderContent-downloadDay20",
    imageEnlargement: modalAdventCalendarImgDay20,
  },
  21: {
    concertLogoImg: consertLogo,
    concertLogoAlt: "V4Mirai 1st Live Concert - Mirai Wonderland",
    concertLogoName: "V4Mirai 1st Live Concert - Mirai Wonderland",
    adventCalendarYoutube1:
      "https://www.youtube.com/embed/tqmxQ0eBVCQ?si=Opcu1xZ5LSLxljBs",
    adventCalendarYoutube2: "https://www.youtube.com/embed/v3So9m6AXz8",
  },
  22: {
    concertLogoImg: consertLogo,
    concertLogoAlt: "V4Mirai 1st Live Concert - Mirai Wonderland",
    concertLogoName: "V4Mirai 1st Live Concert - Mirai Wonderland",
    adventCalendarYoutube1:
      "https://www.youtube.com/embed/k7kz93V99RY?si=ve9GKd9Hep-95Um8",
    adventCalendarYoutube2:
      "https://www.youtube.com/embed/sYZlXy_3eCU?si=fxdVpD1SEns2bFFh",
  },
  23: {
    artistBoxImg1: monoMonet,
    artistBoxImgAlt1: "Mono Monet",
    artistBoxName1: "Mono Monet",
    artistBoxImg2: lykoLianna,
    artistBoxImgAlt2: "Lyko Lianna",
    artistBoxName2: "Lyko Lianna",
    adventCalendarYoutube1:
      "https://www.youtube.com/embed/QaAv9H55HxY?si=Bz6o2insQ25ktaJU",
  },
  24: {
    artistBoxImg1: raraRocora,
    artistBoxImgAlt1: "Rara Rocora",
    artistBoxName1: "Rara Rocora",
    modalAdventCalendarImg: modalAdventCalendarImgDay24,
    downloadImageHref: `${__PATH_PREFIX__}/images/mirai-magical-school-winter-festival_24-94dvK5ildCrPGqc3F8saHFul7xf4Q5.png`,
    downloadImageName: "mirai-magical-school-winter-festival_24.png",
    dataGtmClick: "adventCalenderContent-downloadDay24",
    imageEnlargement: modalAdventCalendarImgDay24,
  },
  25: {
    adventCalendarYoutube1:
      "https://www.youtube.com/embed/-otN-T01iCk?si=-qPige32phbuEUIL",
  },
}

const ModalAdventCalendar = ({ openModal, handleCloseModal, selectedDate }) => {
  const [enlargement, setEnlargement] = useState(false)
  const iframeRef1 = useRef(null)
  const [youtubeSrc1, setYoutubeSrc1] = useState("")
  const iframeRef2 = useRef(null)
  const [youtubeSrc2, setYoutubeSrc2] = useState("")

  const content = adventCalendarContent[selectedDate]

  useEffect(() => {
    if (openModal) {
      document.body.style.overflow = "hidden"
    } else {
      document.body.style.overflow = "auto"
    }

    return () => {
      document.body.style.overflow = "auto"
    }
  }, [openModal])

  useEffect(() => {
    if (openModal && content?.adventCalendarYoutube1) {
      setYoutubeSrc1(content.adventCalendarYoutube1)
    } else {
      setYoutubeSrc1("")
    }

    if (openModal && content?.adventCalendarYoutube2) {
      setYoutubeSrc2(content.adventCalendarYoutube2)
    } else {
      setYoutubeSrc2("")
    }
  }, [openModal, content])

  if (!content) return null

  const handleEnlargement = () => {
    setEnlargement(true)
  }

  const handleClose = () => {
    setEnlargement(false)
    handleCloseModal()
  }

  return (
    <div className={`modal-advent-calendar ${openModal ? "active" : ""}`}>
      <button
        className="modal-bg"
        aria-label="close"
        onClick={handleClose}
      ></button>
      <button
        className="modal-close-button"
        aria-label="close"
        onClick={handleClose}
      ></button>

      {!enlargement && (
        <div className="modal-container">
          <div className="modal-inner">
            {content.artistBoxImg1 && (
              <div className="artist-box-items">
                <div className="artist-box">
                  <div className="artist-box-img">
                    <img
                      src={content.artistBoxImg1}
                      alt={content.artistBoxImgAlt1}
                    />
                  </div>
                  <p className="artist-box-name">{content.artistBoxName1}</p>
                </div>
                {content.artistBoxImg2 && (
                  <div className="artist-box">
                    <div className="artist-box-img">
                      <img
                        src={content.artistBoxImg2}
                        alt={content.artistBoxImgAlt2}
                      />
                    </div>
                    <p className="artist-box-name">{content.artistBoxName2}</p>
                  </div>
                )}
              </div>
            )}
            {content.concertLogoImg && (
              <div className="concert-items">
                <div className="concert-box">
                  <div className="concert-logo">
                    <img
                      src={content.concertLogoImg}
                      alt={content.concertLogoAlt}
                    />
                  </div>
                  <p className="concert-logo-name">{content.concertLogoName}</p>
                </div>
              </div>
            )}
            {content.modalAdventCalendarImg && (
              <div className="modal-advent-calendar-img">
                <img
                  src={content.modalAdventCalendarImg}
                  alt={content.calendarContentImgAlt}
                />
                <button className="magnify-img" onClick={handleEnlargement}>
                  <img src={MagnifierSvg} alt="magnifier" />
                </button>
              </div>
            )}
            {content.adventCalendarYoutube1 && (
              <div className="advent-calendar-youtube">
                <iframe
                  ref={iframeRef1}
                  width="100%"
                  height="100%"
                  src={youtubeSrc1}
                  title="Advent Calendar Content"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                ></iframe>
              </div>
            )}
            {content.adventCalendarYoutube2 && (
              <div className="advent-calendar-youtube">
                <iframe
                  ref={iframeRef2}
                  width="100%"
                  height="100%"
                  src={youtubeSrc2}
                  title="Advent Calendar Content"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                ></iframe>
              </div>
            )}
            {content.downloadImageHref && (
              <a
                className="download-button"
                href={content.downloadImageHref}
                download={content.downloadImageName}
                data-gtm-click={content.dataGtmClick}
              >
                Download
              </a>
            )}
          </div>
        </div>
      )}

      {/* useStateで画像拡大したものと入れ替える */}
      {enlargement && (
        <div className="image-enlargement-wrapper">
          <div className="image-enlargement">
            <img
              src={content.imageEnlargement}
              alt={content.calendarContentImgAlt}
            />
          </div>
        </div>
      )}
    </div>
  )
}

export default ModalAdventCalendar
